// extracted by mini-css-extract-plugin
export default {"root":"LargePlayButton_root__sLB0Y","visible":"LargePlayButton_visible__PN7O7","hidden":"LargePlayButton_hidden__CPgPx","svg":"LargePlayButton_svg__c2tX7"};